import { IFieldValue } from 'Scripts/Slices/loginPage';

import { ITextAreaModel } from 'Types/Litium';
import { IInputValidation } from 'Components/Forms/RenderFormField';

interface TextAreaFieldProps {
    field: ITextAreaModel;
    handleInputChange: (data: IFieldValue) => void;
    error: IInputValidation;
    loading?: boolean;
    cssStyles?: string;
}

const TextAreaField = ({
    field,
    handleInputChange,
    error,
    loading = false,
    cssStyles,
}: TextAreaFieldProps) => {
    const hasError =
        error &&
        'isValid' in error &&
        (!error?.isValid || !error?.isRequiredCriteriaMet);

    const {
        type,
        value,
        name,
        autocomplete,
        maxLength,
        required,
        disabled,
        label,
        validationMessage,
    } = field;

    return (
        <div
            className={`-:relative -:mb-5 -:flex -:flex-col -:px-[1px] ${cssStyles}`}
        >
            <label
                className="font-roboto text-base font-light text-black opacity-100 transition-all peer-focus:top-0 peer-focus:pl-4.5 peer-focus:pt-1.5 peer-focus:text-xs peer-focus:opacity-100 peer-[&:focus:not(:placeholder-shown)]:top-0 peer-[:not(:placeholder-shown)]:top-0 peer-[&:focus:not(:placeholder-shown)]:pr-4.5 peer-[&:focus:not(:placeholder-shown)]:pt-1.5 peer-[:not(:placeholder-shown)]:pr-4.5 peer-[:not(:placeholder-shown)]:pt-1.5 peer-[&:focus:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:text-xs peer-[&:invalid:not(:focus):not(:placeholder-shown)]:text-errorRed peer-[&:focus:not(:placeholder-shown)]:opacity-100"
                htmlFor={name}
            >
                <span className="overflow-hidden text-ellipsis">{label}</span>
                {required && <span className="pl-1">*</span>}
            </label>

            <textarea
                data-invalid={hasError}
                className={`peer mb-4 block max-h-40 w-full max-w-full basis-full scroll-m-6 appearance-none rounded-none border border-solid border-transparent bg-white px-4 pb-1.5 pt-4.5 font-roboto text-base font-light text-black placeholder-opacity-0 outline outline-1 outline-black transition-[outline,_border,_box-shadow,_border-color] duration-layout ease-in-out placeholder:opacity-0 read-only:bg-silver focus:border-black [&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none [&:invalid:not(:focus):not(:placeholder-shown)]:border-errorRed [&:invalid:not(:focus):not(:placeholder-shown)]:text-errorRed  [&:invalid:not(:focus):not(:placeholder-shown)]:outline-errorRed [&:placeholder-show:not(required)]:border-transparent [&[type="number"]]:[appearance:textfield] ${
                    hasError
                        ? 'border-errorRed text-errorRed outline-errorRed'
                        : 'border-black'
                }`}
                value={value}
                onChange={event =>
                    handleInputChange({
                        value: event.target.value,
                        type,
                        name,
                    })
                }
                placeholder={label}
                autoComplete={
                    autocomplete.length > 0 ? autocomplete : undefined
                }
                maxLength={maxLength ? +maxLength : null}
                required={required || undefined}
                readOnly={disabled || loading}
                name={name}
                id={name}
            />

            {error &&
                'isValid' in error &&
                (!error?.isValid || !error?.isRequiredCriteriaMet) && (
                    <span className="-mt-2.5 text-xs text-errorRed">
                        {validationMessage}
                    </span>
                )}
        </div>
    );
};
export default TextAreaField;
